import React, { useEffect, useState } from 'react';
import { listSeoPages, fetchPageHealth, formatSeoApiError } from '../../../utils/adminSeo';

export default function SeoPageHealthScreen() {
  const [pages, setPages] = useState([]);
  const [detail, setDetail] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    listSeoPages({ limit: 80, publish_status: 'published' })
      .then((r) => setPages(r.pages || []))
      .catch((e) => setErr(formatSeoApiError(e)));
  }, []);

  const inspect = (p) => {
    fetchPageHealth(p.id)
      .then(setDetail)
      .catch((e) => setErr(formatSeoApiError(e)));
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-[#1B375B]">Page Health</h2>
      {err && <p className="text-red-600 text-sm">{err}</p>}
      <div className="grid md:grid-cols-2 gap-4">
        <ul className="border rounded bg-white max-h-[60vh] overflow-y-auto text-sm">
          {pages.map((p) => (
            <li key={p.id} className="border-b p-2 flex justify-between">
              <span>
                {p.page_type}/{p.slug} — score {p.entity_health_score ?? '—'}
              </span>
              <button type="button" className="text-[#659A9B] underline text-xs" onClick={() => inspect(p)}>
                Detail
              </button>
            </li>
          ))}
        </ul>
        {detail && (
          <pre className="text-xs bg-gray-50 border rounded p-3 overflow-auto max-h-[60vh]">
            {JSON.stringify(detail, null, 2)}
          </pre>
        )}
      </div>
    </div>
  );
}
